import React, { useState } from 'react';
import Switch from '@mui/material/Switch';
import { FormControlLabel } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';
import { Menu } from '@szhsin/react-menu';
import "./index.css";

interface Props {
    user: any
    alterSetCommentType: Function
    commentTypeList: number[]
}

const FilterComments: React.FC<Props> = (props) => {
    const [localUrl, setLocalUrl] = useState<any>(window.location.pathname);

    const SwitchYellow = styled(Switch)(({ theme }) => ({
        padding: '8px !important',
        color: "white !important",
        '& .MuiSwitch-track': {
            borderRadius: 11,

        },
        '& .MuiSwitch-thumb': {
            boxShadow: 'none',
            width: 16,
            height: 16,
            margin: 2,
        },
    }));

    return (
        <>
            <span>Últimos comentários</span>
            {
                localUrl === '/Attendance' &&
                <div style={{ position: 'absolute', right: '66px' }}>
                    <Menu
                        align={'end'}
                        menuButton={<div className="lciconlink"> <i className="link ppi ppi-filter" /> </div>}
                    >
                        <div style={{ display: 'flex', flexDirection: "column", padding: '15px' }}>
                            <FormControlLabel control={<SwitchYellow value={3} checked={props.commentTypeList.includes(3)} onChange={(e) => props.alterSetCommentType(parseInt(e.target.value))} />} label="Comentários externos" />
                            <FormControlLabel control={<SwitchYellow value={4} checked={props.commentTypeList.includes(4)} onChange={(e) => props.alterSetCommentType(parseInt(e.target.value))} />} label="Comentários concluidos" />
                            <FormControlLabel control={<SwitchYellow value={2} checked={props.commentTypeList.includes(2)} onChange={(e) => props.alterSetCommentType(parseInt(e.target.value))} />} label="E-mail padrão" />
                            <FormControlLabel control={<SwitchYellow value={1} checked={props.commentTypeList.includes(1)} onChange={(e) => props.alterSetCommentType(parseInt(e.target.value))} />} label="Comentários internos" />
                        </div>
                    </Menu>
                </div>
            }
        </>
    );
};

export default FilterComments;